import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_triangle.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconTriangle = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconTriangle;
